/**
 * Pagina de registro.
 * Valida el formulario en cliente y crea una cuenta pendiente de verificacion por correo.
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { buildRegisterPayload, validateRegisterForm } from '../utils/accountValidation';
import { readJsonResponse } from '../utils/http';
import './RegisterPage.css';

function RegisterPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    const validationError = validateRegisterForm({ username, email, password, confirmPassword });
    if (validationError) {
      setMessage(validationError);
      return;
    }

    setIsSubmitting(true);
    setMessage('');
    setIsSuccess(false);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildRegisterPayload({ username, email, password }))
      });

      const data = await readJsonResponse(response, 'No se pudo registrar la cuenta.');

      setMessage(data.message || 'Tu cuenta ha sido creada. Revisa tu correo para verificarla.');
      setIsSuccess(true);
      setUsername('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      console.error(error);
      setMessage(error.message || 'No se pudo registrar la cuenta.');
      setIsSuccess(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main>
      <h2>Crear cuenta</h2>

      <section className="register-card">
        <form className="register-form" onSubmit={handleSubmit}>
          <label htmlFor="username">Nombre de usuario</label>
          <input
            id="username"
            type="text"
            className="register-input"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            maxLength={50}
            autoComplete="username"
          />

          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            className="register-input"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
          />

          <label htmlFor="password">Contrasena</label>
          <input
            id="password"
            type="password"
            className="register-input"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
          />

          <label htmlFor="confirm-password">Confirmar contraseña</label>
          <input
            id="confirm-password"
            type="password"
            className="register-input"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
          />

          <div className="register-actions">
            <button className="register-btn register-btn-primary" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Registrando...' : 'Registrarme'}
            </button>
            <Link to="/login" className="register-link">
              Ya tengo cuenta
            </Link>
          </div>
        </form>

        {message && (
          <p className={`register-message${isSuccess ? ' register-message-success' : ''}`}>
            {message}
          </p>
        )}
      </section>
    </main>
  );
}

export default RegisterPage;
